import { render, staticRenderFns } from "./UpDownCustomer.vue?vue&type=template&id=b90b91ea&scoped=true"
import script from "./UpDownCustomer.vue?vue&type=script&lang=js"
export * from "./UpDownCustomer.vue?vue&type=script&lang=js"
import style0 from "./UpDownCustomer.vue?vue&type=style&index=0&id=b90b91ea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90b91ea",
  null
  
)

export default component.exports